import React, { Component } from "react";
import PageTitle from "../../../commons/components/PageTitle";
import { BtnGroup, Checkbox, CreateForm, FormRow, FormSplit, FormThead } from "../PlantListStyle";
import InputErrorMsgWrapper from "../../../commons/components/input/InputErrorWrap";
import Date from "../../../commons/components/Date";
import DateCustom from "../../../commons/components/DateCustom";

import VS from "../../../commons/services/Validation";
import CS from "../../../commons/services/Common";
import { Form, Message, MessageBox } from "element-react";
import { CONFIRM_TEXT } from "../../../commons/constants/confirm/CONFIRM_TEXT";
import { ROUTES } from "../../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";
import { LabelWidth } from "./translationUiConts";
import SelectBox from "../../../commons/components/select/SelectBox";

const BATTERY_VALID_KEY = (t) => ({
  name: {
    key: "name",
    errMsg: t('key633'), // 배터리명을 입력해주세요.
  },
  model: {
    key: "model",
    errMsg: t('key634'), // MODEL 명을 입력해주세요.
  },
  capacity: {
    key: "capacity",
    errMsg: t('key635'), // 배터리 용량을 입력해주세요.
  },
  siteNo: {
    key: "siteNo",
    errMsg: t('key636'), // Site 번호를 입력해주세요.
  },
  rtuNo: {
    key: "rtuNo",
    errMsg: t("key637"), // RTU 번호를 입력해주세요.
  },
  deviceNo: {
    key: "deviceNo",
    errMsg: t('key638'), // 기기 번호를 입력해주세요.
  },
  operationStartDt: {
    key: "operationStartDt",
    errMsg: t('key639'), // 운전 개시일을 입력해주세요.
  },
  serviceWarrantyDt: {
    key: "serviceWarrantyDt",
    errMsg: t('key640'), //서비스 보증 기간을 입력해주세요.
  }
})

class BatteryCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaved: true,
      projectId: null,
      validationErrors: {},
      selectedBatteryTypeId: 1,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { state } = this.props.location;
    this.setState({ projectId: state.projectId });
  }

  validateForm(data) {
    const { t } = this.props;
    const validationErrors = {};
    
    // 운전 개시일, 서비스 보증기간 validation check
    if (!this.state.operationStartDt) {
      validationErrors[BATTERY_VALID_KEY(t).operationStartDt.key] = BATTERY_VALID_KEY(t).operationStartDt.errMsg;
    }
    if (!this.state.serviceWarrantyDt) {
      validationErrors[BATTERY_VALID_KEY(t).serviceWarrantyDt.key] = BATTERY_VALID_KEY(t).serviceWarrantyDt.errMsg;
    }

    if (this.state.selectedBatteryTypeId === 2 && !data.get("externalUrl")) {
      validationErrors.externalUrl = "연계 URL을 입력해주세요.";
    }

    // formdata를 순회하며 validation check
    for (let [formKey, formValue] of data.entries()) {
      if (formKey === "externalUrl") continue;
      if(!formValue) {
        validationErrors[BATTERY_VALID_KEY(t)[formKey].key] = BATTERY_VALID_KEY(t)[formKey].errMsg;
      }
    }

    this.setState({ validationErrors }, this.scrollErrorInput);

    return Object.keys(validationErrors).length === 0;
  }

  handleDateChange(name, dt) {
    this.setState({
      [name]: dt,
      isSaved: false,
    });
  }

  // 해당 input의 validation error 삭제
  removeError(name) {
    const { validationErrors } = this.state;
    delete validationErrors[name];

    this.setState((prev) => ({ ...prev, validationErrors, isSaved: false }));
  }
  // validation error input으로 스크롤 이동
  scrollErrorInput() {
    const { validationErrors } = this.state;
    const keys = Object.keys(validationErrors);
    // validationErrors에 error가 등록 됐을 때
    if (keys.length > 0) {
      const errorMsgElem = document.querySelector(`.valid-error`); // InputErrorMsgWrapper의 최상단의 span class를 찾음
      errorMsgElem.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  async saveBattery() {
    const { t } = this.props;
    const data = new FormData(document.querySelector("form"));
    if (!this.validateForm(data)) return;
    this.item = {
      // create battery data
      projectId: this.state.projectId,
      name: data.get(BATTERY_VALID_KEY(t).name.key),
      modelName: data.get(BATTERY_VALID_KEY(t).model.key),
      capacity: data.get(BATTERY_VALID_KEY(t).capacity.key),
      siteNo: data.get(BATTERY_VALID_KEY(t).siteNo.key),
      rtuNo: data.get(BATTERY_VALID_KEY(t).rtuNo.key),
      deviceNo: data.get(BATTERY_VALID_KEY(t).deviceNo.key),
      serviceStartDt: this.state.operationStartDt,
      serviceWarrantyDt: this.state.serviceWarrantyDt,
      pwContr: data.get("pwContr") ? 1 : 0,
      tempContr: data.get("tempContr") ? 1 : 0,
      rsdContr: data.get("rsdContr") ? 1 : 0,
      pwModeContr: data.get("pwModeContr") ? 1 : 0,
      timeContr: data.get("timeContr") ? 1 : 0,
      typeId: this.state.selectedBatteryTypeId,
      externalUrl: this.state.selectedBatteryTypeId === 2 ? data.get("externalUrl") : null,
    }
    try {
      const result = await CS.create("/cst/api/battery", this.item)
      return result.isSuccess;
    } catch (error) {
      return false;
    }
    // 서버로 데이터 전송
  }
  async handleSubmit(event) {
    event.preventDefault();
    const isSaved = await this.saveBattery();

    if (isSaved) {
      this.setState({ isSaved: true });
    }
  }

  async linkToBatteryList() {
    const { t } = this.props
    // tab=2: 배터리 리스트
    if (this.state.isSaved) {
      this.props.history.push(ROUTES.PLANT_LIST(this.state.projectId).MAIN + "?tab=2");
      return;
    } 

    MessageBox.confirm(CONFIRM_TEXT.MOVE_TO_LIST, 'Confirm', {
      type: "info",
      confirmButtonText: t('key610'),
      cancelButtonText: t('key611'),
    }).then(() => {
      this.props.history.push(ROUTES.PLANT_LIST(this.state.projectId).MAIN + "?tab=2");
    }).catch(() => {
      Message({
        iconClass: "cancel",
        type: "info",
        message: t('key641'),
      })
    })
    // else {
    //   const isSaved = await this.saveBattery();
    //   if (isSaved) {
    //     this.setState({ isSaved: true });
    //     this.props.history.push("/plant-list/main/" + this.state.projectId + "?tab=2");
    //   }
    // }
  }

  render() {
    const { validationErrors } = this.state;
    const { t, i18n } = this.props;
    const { batteryTypeMapping = [] } = this.props.location.state || {};
    return (
      <>
        <PageTitle title={t('key47')} location={t('key361')} />
        <CreateForm onSubmit={this.handleSubmit}>
          <FormSplit>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>배터리 타입</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors.batteryType}
                message={validationErrors.batteryType}
              >
                <SelectBox 
                  options={batteryTypeMapping}
                  selectedValue={
                    batteryTypeMapping.find(type => type.id === this.state.selectedBatteryTypeId)?.type || ''
                  }
                  onChange={(id) => {
                    this.setState({ selectedBatteryTypeId: id });
                    this.removeError("batteryType");
                  }}
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key363')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors[BATTERY_VALID_KEY(t).name.key]}
                message={BATTERY_VALID_KEY(t).name.errMsg}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={BATTERY_VALID_KEY(t).name.errMsg}
                  onChange={(event) => {
                    this.removeError(BATTERY_VALID_KEY(t).name.key);
                  }}
                  name={BATTERY_VALID_KEY(t).name.key} // name 속성 추가
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key364')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors[BATTERY_VALID_KEY(t).model.key]}
                message={BATTERY_VALID_KEY(t).model.errMsg}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={BATTERY_VALID_KEY(t).model.errMsg}
                  onChange={(event) => {
                    this.removeError(BATTERY_VALID_KEY(t).model.key);
                    VS.onInput("excludeKorean", event);
                  }}
                  name={BATTERY_VALID_KEY(t).model.key} // name 속성 추가
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key365')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors[BATTERY_VALID_KEY(t).capacity.key]}
                message={BATTERY_VALID_KEY(t).capacity.errMsg}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={BATTERY_VALID_KEY(t).capacity.errMsg}
                  onChange={(event) => {
                    this.removeError(BATTERY_VALID_KEY(t).capacity.key);
                    VS.onInput("number", event);
                  }}
                  name={BATTERY_VALID_KEY(t).capacity.key} // name 속성 추가
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key366')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors[BATTERY_VALID_KEY(t).siteNo.key]}
                message={BATTERY_VALID_KEY(t).siteNo.errMsg}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={BATTERY_VALID_KEY(t).siteNo.errMsg}
                  onChange={(event) => {
                    this.removeError(BATTERY_VALID_KEY(t).siteNo.key);
                    VS.onInput("number", event);
                    // VS.onInput("eng&Number", event);
                  }}
                  name={BATTERY_VALID_KEY(t).siteNo.key} // name 속성 추가
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key367')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors[BATTERY_VALID_KEY(t).rtuNo.key]}
                message={BATTERY_VALID_KEY(t).rtuNo.errMsg}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={BATTERY_VALID_KEY(t).rtuNo.errMsg}
                  onChange={(event) => {
                    this.removeError(BATTERY_VALID_KEY(t).rtuNo.key);
                    VS.onInput("number", event);
                    // VS.onInput("eng&Number", event);
                  }}
                  name={BATTERY_VALID_KEY(t).rtuNo.key} // name 속성 추가
                />
              </InputErrorMsgWrapper>
            </FormRow>

            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key368')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors[BATTERY_VALID_KEY(t).deviceNo.key]}
                message={BATTERY_VALID_KEY(t).deviceNo.errMsg}
              >
                <input
                  type="text"
                  className="w436 radius4"
                  placeholder={BATTERY_VALID_KEY(t).deviceNo.errMsg}
                  onChange={(event) => {
                    this.removeError(BATTERY_VALID_KEY(t).deviceNo.key);
                    VS.onInput("number", event);
                    // VS.onInput("eng&Number", event);
                  }}
                  name={BATTERY_VALID_KEY(t).deviceNo.key} // name 속성 추가
                />
              </InputErrorMsgWrapper>
            </FormRow>
            <FormRow>
              <FormThead width={LabelWidth(i18n)} required={true}>{t('key369')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors[BATTERY_VALID_KEY(t).operationStartDt.key]}
                message={BATTERY_VALID_KEY(t).operationStartDt.errMsg}
              >
                <Date
                  name={BATTERY_VALID_KEY(t).operationStartDt.key}
                  handleDateChange={(name, dt) => {
                    this.handleDateChange(name, dt);
                    this.removeError(BATTERY_VALID_KEY(t).operationStartDt.key);
                  }}
                />
              </InputErrorMsgWrapper>
              <FormThead width={LabelWidth(i18n)} className="ml-25" required={true}>{t('key371')}</FormThead>
              <InputErrorMsgWrapper
                isError={validationErrors[BATTERY_VALID_KEY(t).serviceWarrantyDt.key]}
                message={BATTERY_VALID_KEY(t).serviceWarrantyDt.errMsg}
              >
                <DateCustom
                  name={BATTERY_VALID_KEY(t).serviceWarrantyDt.key}
                  handleDateChange={(name, dt) => {
                    this.handleDateChange(name, dt);
                    this.removeError(BATTERY_VALID_KEY(t).serviceWarrantyDt.key);
                  }}
                />
              </InputErrorMsgWrapper>
            </FormRow>
            {
              this.state.selectedBatteryTypeId !== 2 && (

                <FormRow>
                  <FormThead width={LabelWidth(i18n)}>{t('key373')}</FormThead>
                  {/* <InputErrorMsgWrapper
                    isError={true}
                    message="제어 항목을 선택하세요."
                  > */}
                  <Checkbox>
                    <input type="checkbox" name="pwContr" id="power" 
                      onChange={() => {
                        this.setState({ isSaved: false });
                      }}
                    />
                    <label htmlFor="power"></label>
                    <span>{t('key374')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="tempContr" id="temperature" 
                      onChange={() => {
                        this.setState({ isSaved: false });
                      }}
                    />
                    <label htmlFor="temperature"></label>
                    <span>{t('key375')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="rsdContr" id="block" 
                      onChange={() => {
                        this.setState({ isSaved: false });
                      }}
                    />
                    <label htmlFor="block"></label>
                    <span>{t('key376')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="pwModeContr" id="action" 
                      onChange={() => {
                        this.setState({ isSaved: false });
                      }}
                    />
                    <label htmlFor="action"></label>
                    <span>{t('key377')}</span>
                  </Checkbox>
                  <Checkbox>
                    <input type="checkbox" name="timeContr" id="reservation" 
                      onChange={() => {
                        this.setState({ isSaved: false });
                      }}
                    />
                    <label htmlFor="reservation"></label>
                    <span>{t('key378')}</span>
                  </Checkbox>
                  {/* </InputErrorMsgWrapper> */}
                </FormRow>
              )
            }
            {
              this.state.selectedBatteryTypeId === 2 && (
                <FormRow>
                  <FormThead width={LabelWidth(i18n)} required={true}>
                    연계 URL
                  </FormThead>
                  <InputErrorMsgWrapper
                    isError={validationErrors.externalUrl}
                    message={validationErrors.externalUrl}
                  >
                    <input
                      type="text"
                      className="w436 radius4"
                      placeholder="연계 URL을 입력하세요."
                      onChange={(e) => {
                        this.removeError(e.target.name);
                      }}
                      name="externalUrl"
                    />
                  </InputErrorMsgWrapper>
                </FormRow>
              )
            }
          </FormSplit>
          <BtnGroup>
            <button type="button" onClick={() => {
              this.linkToBatteryList(); // 임시 link
            }}>
              {t('key380')}
            </button>
            <button type="submit">{t('key381')}</button>
          </BtnGroup>
        </CreateForm>
      </>
    )
  }
}

export default withTranslation()(BatteryCreate);